/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useProvinceStore = defineStore("province", {
  actions: {
    async provinceListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          "nameTh:contains": payload.nameTh,
          "nameEn:contains": payload.nameEn,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/addr-svc/province/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async provinceInfoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/addr-svc/province/info/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async provinceListAllFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/addr-svc/province/list/all/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async provinceAddFetch(payload) {
      const body = {
        nameTh: payload.nameTh,
        nameEn: payload.nameEn,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/addr-svc/province/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async provinceUpdateFetch(payload) {
      const body = {
        uid: payload.uid,
        nameTh: payload.nameTh,
        nameEn: payload.nameEn,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/addr-svc/province/update";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async provinceDeleteFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/addr-svc/province/delete/" + payload.uid;
          const response = http.delete(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
